import { useEffect, useState } from 'react';
import axios from 'axios';
import { useSnackbar } from '../contexts/SnackbarContext';
import { validarCep } from '../utils/validarCep';

interface RuaResult {
    logradouro: string;
    localidade: string;
    bairro: string;
    uf: string;
    cep: string;
}

interface RuaData {
  rua: string;
  cidade: string;
  bairro: string;
  uf: string;
  cep: string;
}

export const useRua = () => {
  const snackbar = useSnackbar();
  const [loading, setLoading] = useState(false);

  const buscar = async (uf: string, cidade: string, rua: string) => {
    if(!uf?.length || !cidade?.length || !rua?.length) return;

    setLoading(true);
    try {
      const response = await axios.get<RuaResult[]>(`https://viacep.com.br/ws/${uf}/${cidade}/${rua}/json/`);
      const resultados = response.data;

      let ruaData: undefined | RuaData = undefined;

      if(resultados?.length) {
        ruaData = {
          rua: resultados[0].logradouro,
          cidade: resultados[0].localidade,
          bairro: resultados[0].bairro,
          uf: resultados[0].uf,
          cep: resultados[0].cep,
        };
      }
      
      return ruaData;
    } catch (error) {
      snackbar("Rua não encontrada", { severity: "error" });
    }
    setLoading(false);
  };

  return { buscar, loading };
};
